import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, Loader2, ArrowLeft } from "lucide-react";
import { API } from "../lib/api";

const SEVERITY = { high: "text-red-300", medium: "text-amber-300", low: "text-sky-300", info: "text-zinc-300" };

export default function AdvisoryPublic() {
  const { advisoryId } = useParams();
  const [adv, setAdv] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/advisories/${advisoryId}`)
      .then(({ data }) => { setAdv(data.advisory); document.title = `Security advisory: ${data.advisory.title}`; })
      .catch(() => setError("This advisory isn't available to share."));
  }, [advisoryId]);

  return (
    <div className="min-h-screen bg-[#060607] text-zinc-100 px-6 sm:px-12 py-16" data-testid="advisory-public-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 hover:text-zinc-200 inline-flex items-center gap-2 mb-10 transition-colors" data-testid="advisory-public-home">
          <ArrowLeft className="h-3 w-3" /> Projectivy Sentinel
        </Link>
        {error ? (
          <p className="text-sm text-zinc-400" data-testid="advisory-public-error">{error}</p>
        ) : !adv ? (
          <Loader2 className="h-5 w-5 animate-spin text-zinc-500" data-testid="advisory-public-loading" />
        ) : (
          <article className="animate-in fade-in slide-in-from-bottom-2 duration-500">
            <div className="text-[10px] uppercase tracking-[0.35em] text-emerald-400 mb-3 inline-flex items-center gap-2">
              <ShieldCheck className="h-3.5 w-3.5" /> security advisory · fixed
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl tracking-[0.05em] leading-tight" data-testid="advisory-public-title">{adv.title}</h1>
            <div className="mt-4 flex gap-4 text-[11px] uppercase tracking-[0.25em]">
              <span className={SEVERITY[adv.severity]} data-testid="advisory-public-severity">{adv.severity} severity</span>
              <span className="text-zinc-500">reported {new Date(adv.created_at).toLocaleDateString()}</span>
            </div>
            <section className="mt-10">
              <h2 className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-2">What happened</h2>
              <p className="text-base text-zinc-300 leading-relaxed" data-testid="advisory-public-summary">{adv.summary}</p>
            </section>
            {adv.solution && (
              <section className="mt-8 border-l-2 border-emerald-500/60 pl-5">
                <h2 className="text-[10px] uppercase tracking-[0.3em] text-emerald-400 mb-2">How it was fixed</h2>
                <p className="text-base text-zinc-200 leading-relaxed" data-testid="advisory-public-solution">{adv.solution}</p>
              </section>
            )}
            <p className="mt-12 text-xs text-zinc-600">Last updated {new Date(adv.updated_at).toLocaleString()}</p>
          </article>
        )}
      </div>
    </div>
  );
}
